import { render, staticRenderFns } from "./PostCreation_Text.vue?vue&type=template&id=cc6c8f58&"
import script from "./PostCreation_Text.vue?vue&type=script&lang=js&"
export * from "./PostCreation_Text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports